<template>
  <v-container fluid pa-0 fill-height>
    <v-row class="fill-height ma-0">
      <v-col md="6" sm="12" class="align-center justify-center d-flex" style="background-color: #F2F2FB">
        <v-row justify="center">
          <login-card
            :isAgent="false"
            @forgot-password="changePassword"
            v-show="!forgotPassword"
          />
          <forgot-password
            v-show="forgotPassword"
            @backToLogin="changePassword"
          />
        </v-row>
      </v-col>
      <v-col md="6" class="login-image system d-none d-md-flex align-end justify-end">
        <v-row justify="end" class="z-1 p-relative py-10 px-11">
          <logo
            url="/images/logo-benfeitores-branco.svg"
            alt="Logo Benfeitores"
            width="120"
          />
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LoginCard from "@/components/LoginCard";
import ForgotPassword from "@/components/ForgotCard";
import Logo from "@/components/Logo";
export default {
  name: "Login",
  inject: ["theme"],
  components: {
    LoginCard,
    ForgotPassword,
    Logo
  },
  data: () => ({
    forgotPassword: false
  }),
  methods: {
    changePassword() {
      this.forgotPassword = !this.forgotPassword;
    }
  }
};
</script>

<style lang="scss" scoped>
.copyright {
  font-size: 12px;
  text-align: center;
  color: #6c7293;
  position: absolute;
  bottom: 20px;
}

.login-image {
  width: 100%;
  height: 100%;
  position: relative;
  background: rgb(112, 77, 250);
  background-image: linear-gradient(-63deg, #704DFA 20%, #5DCEF2 120%);
}

.login-image:after {
  content: "";
  display: block;
  background-image: url(https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=80);
  background-size: cover;
  background-position: center;
  position: absolute;
  opacity: 0.2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  filter: grayscale(1);
}
</style>
